module.exports = __webpack_public_path__ + "static/media/endeavor.25c3c5ea.JPG";